export const TokenConstants = {
    Session_Expired: 'Your session has expired. Please log in again.'
};

export const ErrorMessageConstants = {
    Message: 'Something went wrong! Please try again after some time.'
};

